import React from 'react';

const FormSection = (props) => (
  <div className="form-section">{props.children}</div>
);

export default FormSection;
